import platform from "Pub/js/platform";
import pubSubActions from "Pub/js/pubSubActions";
import { OSnow } from 'Pub/js/utils';
const { PubSub } = platform;

/**
 * 全局快捷键，主要为了监听在iframe内触发的快捷键
 *
 */
export const HOTKEY_ACTIONS = {
    SPR: evt => evt.ctrlKey && evt.keyCode == 192, //录制spr ctrl+`
    HELP: evt => {
        if (OSnow() !== 'mac') {
            return evt.ctrlKey && evt.keyCode == 112;
        } else {
            return (evt.metaKey || evt.ctrlKey) && evt.keyCode == 112;
        }
    }, // 帮助中心 ctrl+F1
    INSIDETABCLOSE: evt => evt.ctrlKey && evt.altKey && evt.keyCode == 81, // 内部页签关闭 ctrl+alt+q
};

const hotKeysDecorator = (hotkey, action) => {
    return event => {
        let evt = event || window.event || arguments.callee.caller.arguments[0];
        if (hotkey && hotkey(evt) && typeof action === 'function') {
            action();
        }
    };
};

/**
 * 绑定快捷键
 * 
 * @param {*} hotkeys 快捷键
 * @param {*} action 快捷键执行的动作
 */
const bindHotKeys = (hotkeys, action) => {
    const hotkey = typeof hotkeys === 'function' ? hotkeys(HOTKEY_ACTIONS) : hotkeys;
    document.addEventListener("keydown", hotKeysDecorator(hotkey, action));
    //监听iframe内的键盘事件
    window[`${hotkey.name}PubSub`] = PubSub.subscribe(pubSubActions.global.onIframeKeydown, (key, event) => {
        hotKeysDecorator(hotkey, action)(event);
    });
};

/**
 * 移除快捷键
 * 
 * @param {*} hotkey 快捷键
 * @param {*} action 快捷键执行的动作
 */
const removeHotKeys = (hotkey, action) => {
    document.removeEventListener("keydown", hotKeysDecorator(hotkey, action));
    PubSub.unsubscribe(window[`${hotkey.name}PubSub`]); //移除订阅
};

export const globalHotKeys = {
    bind: bindHotKeys,
    remove: removeHotKeys,
};